// extracted by mini-css-extract-plugin
export default {"thumbnailTextList":"ThumbnailTextList_thumbnailTextList__cUGzA","thumbnailTextItem":"ThumbnailTextList_thumbnailTextItem__XCgpC"};